"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MNEMONIC = void 0;
const constants_1 = require("../constants");
exports.MNEMONIC = constants_1.ExtensionName[constants_1.ExtensionId.mval];
